;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "ve0lahgjzgd"							}), success: c, error: e});						}, cb  = function(section, $) {;var cb  = function($) {
//Show/Hide menu in mobile
 var _this = jQuery(this);
 let $menu = _this.find('.lh-menu');
  _this.find('.lh-icon').click(function(e){
        $menu.toggleClass('open')     
    });
    _this.find('.lh-header-menu').click(function(e){
       let target = jQuery(e.target);
       if (!target.closest('.lh-menu').length){
       	$menu.removeClass('open');
   }
    });
   
 };						cb.bind($('section[data-section-id="ve0lahgjzgd"]').get(0))(jQuery);};					cb.bind($('section[data-section-id="ve0lahgjzgd"]').get(0))({						url: "https://library.layouthub.com/HUB/files/TWFyLS0yMDIx/NjE1Mjc3MDI3/release-3-2021/pages/dYquXFtvam68ni4E/header/",						settings: {}					}, jQuery);})(jQuery);;console.log('This page layout has been built by https://www.layouthub.com');